import React from 'react';
import CvSkills from '../../AboutMe/DigitalResume/CvSkills';

const Skills = () => {
  return (
    <CvSkills />
  )
}

export default Skills